export const accessOptions = {
  DASHBOARD: 1,
  GENERATE_TICKETS: 2,
  MONITOR: 3,
  MONITOR_ASSIGNMENT: 4,
  ATTENTION_MONITOR: 5,
  BOX: 6,
  ASSIGNMENT_BOX: 7,
  ATTENTION_BOX: 8,
};

export const platform = {
  GESCOL: 14,
};
